import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { browserSession } from '../services/utils/browserSession';

interface Responses {
  [key: number]: any;
}

interface QuestionContextType {
  responses: Responses;
  answerId: number | null;
  saveDataAnswerOnStorage: any;
  saveResponse: (questionId: number, answer: any) => void;
  currentQuestionIndex: number | null;
  setCurrentQuestionIndex: any;
  removeAnswer: any;
  setResponses: any;
}

const QuestionContext = createContext<QuestionContextType>({
  responses: {},
  saveResponse: () => {},
  currentQuestionIndex: null,
  setCurrentQuestionIndex: () => {},
  answerId: null,
  removeAnswer: () => {},
  saveDataAnswerOnStorage: () => {},
  setResponses: () => {},
});

export const useQuestions = () => useContext(QuestionContext);

interface QuestionProviderProps {
  children: ReactNode;
}

export const QuestionProvider: React.FC<QuestionProviderProps> = ({ children }) => {
  const [answerId, setAnswerId] = useState<number | null>(null);
  const [responses, setResponses] = useState<Responses>({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState<number | null>(null);

  const saveResponse = (questionId: number, answer: any) => {
    setResponses((prevResponses) => ({
      ...prevResponses,
      [questionId]: answer,
    }));
  };

  useEffect(() => {
    try {
      const storedQuestion = window.localStorage.getItem('zenbox.question');

      if (storedQuestion) {
        const dataQuest = JSON.parse(storedQuestion);

        if (dataQuest?.answer_id) {
          setAnswerId(dataQuest.answer_id);
        }
      }
    } catch {
      // storage indisponível: segue apenas com memória
    }
  }, []);

  const saveDataAnswerOnStorage = (id: any) => {
    setAnswerId(id);

    try {
      window.localStorage.setItem(
        'zenbox.question',
        JSON.stringify({
          answer_id: id,
        })
      );
    } catch {
      // storage indisponível: mantém apenas em memória
    }
  };

  const removeAnswer = () => {
    try {
      window.localStorage.removeItem('zenbox.question');
    } catch {
      // storage indisponível: limpa apenas memória
    }

    setAnswerId(null);
    setResponses({});
    setCurrentQuestionIndex(0);
  };

  return (
    <QuestionContext.Provider
      value={{
        responses,
        saveResponse,
        currentQuestionIndex,
        answerId,
        removeAnswer,
        setResponses,
        saveDataAnswerOnStorage,
        setCurrentQuestionIndex,
      }}
    >
      {children}
    </QuestionContext.Provider>
  );
};